// extracted by mini-css-extract-plugin
module.exports = {"appBar":"opteraAppBar_appBar___BigP","logo":"opteraAppBar_logo__egdK8","navItem":"opteraAppBar_navItem__j0mDm","switchButton":"opteraAppBar_switchButton__zzx5V"};